import { Account } from 'store/api/types';

export const ADD_ACCOUNT = 'accounts/add';
export const REMOVE_ACCOUNT = 'accounts/remove';
export const SET_ACTIVE_ACCOUNT = 'accounts/set_active';
export const UPDATE_ACCOUNT = 'accounts/update_account';
export const RESET_ACTIVE_ACCOUNT = 'accounts/reset_active_account';

export const accountsReducer = (
  state: {
    accounts: Account[];
    activeAccount?: Account;
  },
  action: { uuid?: string; account?: Account; type: string },
) => {
  switch (action.type) {
    case ADD_ACCOUNT:
      if (!action.account) {
        throw new Error();
      }

      return {
        ...state,
        accounts: [...state.accounts, action.account],
      };
    case SET_ACTIVE_ACCOUNT:
      if (!action.uuid) {
        throw new Error();
      }

      return {
        ...state,
        activeAccount: state.accounts.find(a => a.uuid === action.uuid),
      };
    case REMOVE_ACCOUNT:
      if (!action.uuid) {
        throw new Error();
      }

      return {
        ...state,
        accounts: state.accounts.filter(a => action.uuid && a.uuid !== action.uuid),
      };
    case RESET_ACTIVE_ACCOUNT:
      return {
        ...state,
        activeAccount: undefined,
      };
    case UPDATE_ACCOUNT:
      if (!action.account) {
        throw new Error();
      }

      const account = action.account as Account;

      return {
        ...state,
        accounts: state.accounts.map(a => (a.uuid === account.uuid ? account : a)),
        activeAccount:
          state.activeAccount && action.account.uuid === state.activeAccount.uuid ? account : state.activeAccount,
      };
    default:
      throw new Error();
  }
};
